"use client";

import { useEffect, useRef, useState } from "react";

/* Dashboard "Vendas hoje" com o dia acontecendo: o total sobe a cada
   nova venda, os pedidos contam, um badge "+R$" flutua e as barras
   avançam — decisão guiada por dados, ao vivo. */

const fmt = (v: number) =>
  Math.round(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });

export default function MockVendas() {
  const raiz = useRef<HTMLDivElement>(null);
  const [on, setOn] = useState(false);
  const [vendas, setVendas] = useState(48920);
  const [pedidos, setPedidos] = useState(312);
  const [ultimaVenda, setUltimaVenda] = useState<{ id: number; valor: number } | null>(null);
  const [barras, setBarras] = useState([34, 52, 40, 68, 58, 82, 74, 63]);

  useEffect(() => {
    const el = raiz.current;
    if (!el) return;
    if (el.getBoundingClientRect().top < window.innerHeight * 0.95) {
      setOn(true);
      return;
    }
    const io = new IntersectionObserver(
      ([e]) => e.isIntersecting && (setOn(true), io.disconnect()),
      { threshold: 0.3 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    if (!on) return;
    let vivo = true;
    let id = 1;
    let timer: ReturnType<typeof setTimeout>;
    const tick = () => {
      if (!vivo) return;
      const valor = Math.round((90 + Math.random() * 420) / 10) * 10;
      setVendas((v) => v + valor);
      setPedidos((p) => p + 1);
      setUltimaVenda({ id: id++, valor });
      setBarras((b) => {
        const nova = [...b];
        nova[nova.length - 1] = Math.min(100, nova[nova.length - 1] + 2 + Math.random() * 4);
        return nova;
      });
      timer = setTimeout(tick, 2000 + Math.random() * 1800);
    };
    timer = setTimeout(tick, 1200);
    return () => {
      vivo = false;
      clearTimeout(timer);
    };
  }, [on]);

  const ticket = vendas / pedidos;

  return (
    <div ref={raiz} className="pointer-events-none select-none rounded-card border border-white/10 bg-ink p-5 shadow-[0_30px_60px_-30px_rgba(0,0,0,0.8)]">
      <div className="flex items-center justify-between">
        <span className="text-sm font-semibold text-paper">Vendas hoje</span>
        <span className="inline-flex items-center gap-1.5 rounded-full border border-white/15 px-2.5 py-1 text-[11px] font-semibold text-paper/70">
          <span className="relative flex h-1.5 w-1.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-lime opacity-70" />
            <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-lime" />
          </span>
          ao vivo
        </span>
      </div>

      <div className="relative mt-1 flex items-baseline gap-3">
        <div className="font-display text-3xl font-bold text-paper transition-all">
          {fmt(vendas)}
        </div>
        {ultimaVenda && (
          <span
            key={ultimaVenda.id}
            className="animate-[reveal-up_0.5s_cubic-bezier(0.22,1,0.36,1)] rounded-full bg-lime/15 px-2 py-0.5 text-[11px] font-bold text-lime"
          >
            + {fmt(ultimaVenda.valor)}
          </span>
        )}
      </div>
      <div className="text-xs font-semibold text-lime">+18% vs. ontem</div>

      <div className="mt-4 flex h-24 items-end gap-1.5">
        {barras.map((h, i) => (
          <div
            key={i}
            style={{ height: `${h}%` }}
            className={`flex-1 rounded-t-md transition-all duration-700 ${
              i === barras.length - 1 ? "bg-lime" : "bg-white/12"
            }`}
          />
        ))}
      </div>

      <div className="mt-3 grid grid-cols-3 gap-2 text-center text-[11px] text-smoke-dark">
        <div className="rounded-xl bg-white/5 py-2">
          <div className="font-bold text-paper">{pedidos}</div>
          pedidos
        </div>
        <div className="rounded-xl bg-white/5 py-2">
          <div className="font-bold text-paper">3,4%</div>
          conversão
        </div>
        <div className="rounded-xl bg-white/5 py-2">
          <div className="font-bold text-paper">{fmt(ticket)}</div>
          ticket médio
        </div>
      </div>
    </div>
  );
}
